import React from 'react';
import { formatDisplayDateTime } from '@/config';
import { Modal, Table, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { PassengerProfileHistoryModel } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { GenderType } from '@/constants';

type Props = {
  passengerId: string;
  onClose: () => void;
};

/** Historique d'une fiche : corrections champ par champ (vente confirmée, back-office) et copie propre à la compagnie. */
export default function PassengerHistoryModal({ passengerId, onClose }: Props) {
  const { t } = useTranslation();
  const [rows, setRows] = React.useState<PassengerProfileHistoryModel[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    apiSdk.BookingPassengerService.passengerHistory({ id: passengerId })
      .then(setRows)
      .catch(message.error)
      .finally(() => setLoading(false));
  }, [passengerId]);

  // Sexe enregistré par le serveur en nom d'énumération (Male, Female) : affiché traduit.
  const value = (field?: string | null, v?: string | null) => (field === 'Gender' && v ? GenderType.__getValue(v) || v : v);

  return (
    <Modal open={true} width={900} title={t('passengerHistory_Title')} footer={null} onCancel={onClose}>
      <Table<PassengerProfileHistoryModel>
        data-testid="passenger-history"
        rowKey={(r, i) => `${r.operationId}-${r.field}-${i}`}
        loading={loading}
        dataSource={rows}
        pagination={false}
        size="small"
        locale={{ emptyText: t('passengerHistory_Empty') }}
        columns={[
          { title: t('passengerHistory_Date'), dataIndex: 'changedOn', render: v => formatDisplayDateTime(v) },
          { title: t('passengerHistory_Source'), dataIndex: 'source', render: v => t(`passengerHistory_Source_${v}`) },
          { title: t('passengerHistory_Field'), dataIndex: 'field', render: v => t(`passengerHistory_Field_${v}`) },
          { title: t('passengerHistory_Old'), dataIndex: 'oldValue', render: (v, r) => value(r.field, v) },
          { title: t('passengerHistory_New'), dataIndex: 'newValue', render: (v, r) => value(r.field, v) },
          { title: t('passengerHistory_By'), dataIndex: 'changedByName' },
        ]}
      />
    </Modal>
  );
}
